import {createElement} from 'rlink-react';
import RoutingComponent from 'rlink-router/component';
import {PromotionTilePanel} from 'rlink-promotiles/component';
import css from 'styles/news.less';
export default function (params, content) {
  let layoutType = (params.displayLocation === 'home') ? 'tiling' : 'horizontal';
  return (<RoutingComponent title="news">
    <style key="styles">{`
      body {
        height: 100%;
        overflow: hidden;
      }
      ::-webkit-scrollbar {
          display: none;
      }
    `}</style>
    <PromotionTilePanel key="news"
      css={css}
      content={content.promotionTiles.data.get('items')}
      layoutType={layoutType} />
  </RoutingComponent>);
}



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/views/news.jsx